import React, { useState, useEffect } from "react";
import { useQuery } from "@apollo/client";
import { Box, useTheme, useMediaQuery } from "@mui/material";
import { Header } from "../../components/layout/header/header";
import { GET_USER } from "../../apollo-client/queries";
import { useHistory, useRouteMatch } from "react-router-dom";
import { FormattedMessage } from "react-intl";
import { getSelectedArea } from "../../services/url-helpers";
import { showInfoToast } from "../../toast/toast-service";
import { ProfilePageDesktopLayout } from "./components/ProfilePageDesktopLayout";
import { ProfilePageMobileLayout } from "./components/ProfilePageMobileLayout";
import { ProfilePageContent } from "./components/ProfilePageContent";
import { navigationItems } from "./components/ProfileNavigation";

export const ProfilePage = (props) => {
  const { data } = useQuery(GET_USER);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  const routeMatch = useRouteMatch();
  const profileSubdomain = routeMatch.path.split("/");
  const currentPath = routeMatch.path;
  const selectedArea = getSelectedArea(currentPath);

  // On mobile, show navigation by default if no subdomain is selected
  // If subdomain is selected, show content by default
  const [showMobileNavigation, setShowMobileNavigation] = useState(
    isMobile ? !profileSubdomain[2] : true
  );

  const history = useHistory();

  // Update mobile navigation state when route changes
  useEffect(() => {
    if (isMobile) {
      setShowMobileNavigation(!profileSubdomain[2]);
    }
  }, [profileSubdomain[2], isMobile]);

  const handleNavigation = (item) => {
    if (!item.available) {
      if (item.comingSoon) {
        showInfoToast(<FormattedMessage id="feature-coming-soon" />);
      }
      return;
    }

    // Navigate to the selected route
    history.push(item.path);

    // On mobile, switch to content view after navigation
    if (isMobile) {
      setShowMobileNavigation(false);
    }
  };

  const handleBackToNavigation = () => {
    if (isMobile) {
      setShowMobileNavigation(true);
    }
  };

  const getCurrentPageTitle = () => {
    const currentItem = navigationItems.find(
      (item) =>
        selectedArea === `profile/${item.id}` ||
        (selectedArea === "profile" && item.id === "my-teachings")
    );
    return currentItem ? currentItem.label : "header.menu-edit-profile";
  };

  return (
    <Box
      sx={{
        width: "100%",
        maxWidth: "100vw",
        overflow: "hidden",
      }}
    >
      {/* Header - Always at the top, full width */}
      <Header error={false} loading={false} props={props} />

      {/* Render appropriate layout based on screen size */}
      {isMobile ? (
        <ProfilePageMobileLayout
          showMobileNavigation={showMobileNavigation}
          selectedArea={selectedArea}
          onNavigation={handleNavigation}
          onBackToNavigation={handleBackToNavigation}
          currentPageTitle={getCurrentPageTitle()}
        >
          <ProfilePageContent profileSubdomain={profileSubdomain} />
        </ProfilePageMobileLayout>
      ) : (
        <ProfilePageDesktopLayout
          selectedArea={selectedArea}
          onNavigation={handleNavigation}
        >
          <ProfilePageContent profileSubdomain={profileSubdomain} />
        </ProfilePageDesktopLayout>
      )}
    </Box>
  );
};
